/**
 * OTURUM SAHİBİ — /auth/me'den TAZE okunur.
 *
 * Neden localStorage yetmiyor: `getStoredUser()` girişte yazılan bir kopya. Kullanıcı
 * Google hesabını sonradan bağladığında profil fotoğrafı sunucuda oluşuyor ama yerel
 * kopyada olmuyor; avatar ancak çıkış-giriş yapılınca görünüyordu. Paket/rol değişimi
 * de aynı şekilde geç yansıyordu.
 *
 * localStorage kopyası ilk kare için başlangıç verisi olarak kullanılır — kart boş
 * yanıp sönmesin diye.
 */
import { useQuery } from "@tanstack/react-query";
import { getStoredUser } from "@/lib/auth";

export type Ben = {
  id: number;
  email: string;
  name: string;
  packageId: number | null;
  isAdmin: boolean;
  avatarUrl: string | null;
  role: string;
};

export function useMe() {
  const kayitli = getStoredUser();
  return useQuery({
    queryKey: ["auth-me"],
    staleTime: 60_000,
    // `initialData` DEĞİL, `placeholderData`. initialData önbelleğe GERÇEK veri olarak
    // yazılıyor ve staleTime boyunca taze sayılıyor → ilk istek hiç atılmıyordu.
    // localStorage kopyasında avatarUrl null olduğu için kart baş harflerde takılı
    // kalıyordu (Google ile giriş yapılmış ve fotoğraf sunucuya yazılmış olmasına rağmen).
    // placeholderData yalnız ilk kareyi doldurur, istek yine de gider.
    placeholderData: kayitli
      ? { ...kayitli, packageId: null, isAdmin: false, avatarUrl: null, role: "" } as Ben
      : undefined,
    queryFn: async (): Promise<Ben | null> => {
      try {
        const r = await fetch("/api/auth/me");
        if (!r.ok) return null;
        return (await r.json()).user ?? null;
      } catch { return null; }
    },
  });
}
